import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Exhibitor } from '@planone/shared/util-interfaces';

@Component({
  selector: 'planone-contact-exhibitor',
  templateUrl: './contact-exhibitor.component.html',
  styleUrls: ['./contact-exhibitor.component.scss'],
})
export class ContactExhibitorComponent {
  @Input() hideDescription = false;
  @Input() hideLocation = false;
  @Input() exhibitor?: Exhibitor | null = undefined;
  @Input() email?: string = undefined;
  @Input() exhibitorClickable = true;

  @Output() linkClick = new EventEmitter<{
    element: EventTarget | null;
    linkText: string | undefined;
    linkType: string;
  }>();
}
